export enum TableauView {
  EVENTS = 'Events/Events',
  JUSTICE_INVOLVED = 'JusticeInvolved/JusticeInvolved',
  END_USER = 'EndUser/EndUser',
}
